export default __webpack_public_path__ + "static/media/id.5d72627d.jpg";